import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from '~spa/Components/Link/Link';
import EventDescription from '~shared/components/react/EventDescription';

import {
    I18N_CHANGE_EVENT_SEE_ALL,
    MORE_GAMES_GTM_CLOSE,
    MORE_GAMES_GTM_SEE_ALL,
    MORE_GAMES_GTM_CLICK_EVENT,
} from './constants';

const MoreGamesPopup = ({
    isOpen,
    setOpen,
    maxHeight,
    width,
    left,
    top,
    bgHeight,
    tournamentUrl,
    events,
    gtmAttribute,
}) => {
    const [ t ] = useTranslation();
    const eventsContainerRef = useRef(null);
    const [scrollBarVisible, setScrollBarVisible] = useState(false);

    useEffect(() => {
        if(eventsContainerRef && eventsContainerRef.current) {
            setScrollBarVisible(eventsContainerRef.current.clientHeight !== eventsContainerRef.current.scrollHeight);
        }
    }, [events]);


    return (
        isOpen
        ? <>
            <div
                style={{
                    width,
                    left,
                    top,
                    height: bgHeight,
                }}
                className="more-game-events-widget__overlay-background"
                onClick={($event) => {
                    setOpen(false);
                    $event.stopPropagation();
                }}
                data-spectate-product={`${gtmAttribute};${MORE_GAMES_GTM_CLOSE}`}
            />
            <div
                className="more-game-events-widget__overlay"
                style={{
                    maxHeight,
                }}
            >
                <div ref={eventsContainerRef} className="more-game-events-widget__events-container">
                    <div className={`gradient-top${ !scrollBarVisible ? '--hidden' : '' }`}></div>
                    {
                        events.map((event) => {
                            const markets = Object.values(event.markets || {});
                            const hasBoostedOddsSelections = markets.some(market => market.boosted_odds);

                            return (
                                <EventDescription
                                    key={event.id}
                                    event={event}
                                    gtm={`${gtmAttribute};${MORE_GAMES_GTM_CLICK_EVENT}`}
                                    hasBoostedOddsSelections={hasBoostedOddsSelections}
                                />
                            );
                        })
                    }
                </div>
                <div
                    className="more-game-events-widget__see-all-container"
                    style={{
                        width,
                    }}
                >
                    <div className={`gradient-bottom${ !scrollBarVisible ? '--hidden' : '' }`}></div>
                    <Link
                        to={tournamentUrl}
                    >
                        <div
                            className="more-game-events-widget__see-all"
                            data-spectate-product={`${gtmAttribute};${MORE_GAMES_GTM_SEE_ALL}`}
                        >
                            {t(I18N_CHANGE_EVENT_SEE_ALL)}
                        </div>
                    </Link>
                </div>
            </div>
        </>
        : null
    );
};

MoreGamesPopup.propTypes = {
    isOpen: PropTypes.bool,
    setOpen: PropTypes.func,
    maxHeight: PropTypes.number,
    width: PropTypes.number,
    left: PropTypes.number,
    top: PropTypes.number,
    bgHeight: PropTypes.number,
    tournamentUrl: PropTypes.string.isRequired,
    events: PropTypes.array.isRequired,
    gtmAttribute: PropTypes.string,
};

MoreGamesPopup.defaultProps = {
    isOpen: false,
    setOpen: Function.prototype,
    maxHeight: 0,
    width: 0,
    left: 0,
    top: 0,
    bgHeight: 0,
    gtmAttribute: '',
};

export default MoreGamesPopup;
